// MyThink5WhysGroups.js
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import MainLayout from '../../layouts/MainLayout';
import ElapsedTime from '../../components/ElapsedTime';

import "../../styles/MyProfile.css";

const MyThink5WhysGroups = () => {
  const authState = useSelector(state => state.authReducer);
  // console.log(authState);

  const handleClose = () => {
    navigate("/my-profile-home");
  };

  const formatDate = (date) => {
    if (!(date instanceof Date)) {
      return "Invalid Date";
    }

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  }


  return (
    <MainLayout>
      <div className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>
        <h2>Profile - My Think5Whys Groups</h2>
      </div>
      <div className='flex justify-center items-center m-auto my-2 p-2 border-2 shadow-md rounded-md md:w-7/12 w-full text-white'>
        <div className='mt-4 '>
          <p>Name: {authState.user.name}</p>
          <p>Email: {authState.user.email}</p>
          <div className='mt-4 '>
            <p className='text-m'>Registration Date: {formatDate(new Date(authState.user.joiningTime))}</p>
          </div>
          <div>
            <ElapsedTime startTime={new Date(authState.user.joiningTime)} />
          </div>
          <div className='mt-4 '>
            <p className='text-2xl  text-yellow-300'>Think5Whys Code: {authState.user.think5whyscode}</p>
          </div>
          <div className='mt-4'>
            <button className='cancel-button' onClick={handleClose}>Close</button>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default MyThink5WhysGroups;


